import { getUrlQuery } from '../utils/utils';
import { ListFormat } from '@tencent/alloy-editor';
import { getConvertAutoNumCharacterText } from '../utils/character-utils/auto-num-type';
import { getLiteCharacterLevel, mergeFirstTextRunAndParaStyle, mergeBulletAttribute } from '../utils/character-utils';
import { isParaEmpty } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/utils';
import { getBuiltInBulletConfig } from '../utils/character-utils/built-in-bullet';
import { processTextFontFamily } from '../utils/font-utils';
import { isSupportFontFamily } from '../utils/check-font-is-supported';

const EDIT_EMPTY_PARA_INDEX_OPACITY = 0.3;

// eslint-disable-next-line complexity
export function createCharacterProps(paragraph, index, paragraphs, editParaIndex?, isEditing = true) {
    const { character, level } = paragraph.paragraphProps;
    const needCharacter = character && !character.buNone;
    if (!needCharacter) {
        return;
    }
    let opacity = 1;
    if (typeof editParaIndex !== 'undefined' && isParaEmpty(paragraph)) {
        // 只有在编辑态才显示半透明的项目符号
        opacity  = editParaIndex === index && isEditing ? EDIT_EMPTY_PARA_INDEX_OPACITY : 0;
    }
    const firstTextRunAndParaStyle = mergeFirstTextRunAndParaStyle(paragraph);
    const characterStyle = mergeBulletAttribute(firstTextRunAndParaStyle);
    if (characterStyle.fontFamily) {
        characterStyle.fontFamily = processTextFontFamily(characterStyle.fontFamily);
    }
    const { character_bullet_char: characterBulletChar, buAutoNum, buBlip } = character;
    if (characterBulletChar) {
        return convertBullet({ character, level, characterStyle, opacity });
    }
    if (buAutoNum) {
        return convertNumbered({ character, level, index, paragraphs, characterStyle, opacity });
    }
    if (buBlip) {
        return convertImage({ character, level, characterStyle, opacity });
    }
    return;
}

function convertBullet({ character, level, characterStyle, opacity }) {
    const { character_bullet_char: characterBulletChar, buSzPct = 1, buFont } = character;
    const builtInBullet = getBuiltInBulletConfig(characterBulletChar, buFont?.typeface);
    let char = characterBulletChar;
    let fontFamily = buFont?.typeface ? `"${buFont?.typeface}"` : '';
    if (builtInBullet) {
        // 如果是内置项目符号，判断是否支持指定字体
        const isSupport = isSupportFontFamily(buFont?.typeface, characterBulletChar);
        if (!isSupport) {
            // 如果不支持，切换为 backup 字符
            const { backup } = builtInBullet;
            char = backup.char;
            fontFamily = backup.fontFamily;
        }
    }
    return {
        listLevel: level,
        listFormat: ListFormat.Bullet,
        levelText: char,
        color: characterStyle.color,
        fontSize: characterStyle.fontSize * buSzPct,
        fontFamily,
        opacity,
    };
}

function convertNumbered({ character, level, index, paragraphs, characterStyle, opacity }) {
    const { buAutoNum, buSzPct = 1 } = character;
    // 运行时动态计算当前项目符号的 index
    const characterIndex = getLiteCharacterLevel({ index, character, level, paragraphs });
    return {
        listLevel: level,
        listFormat: ListFormat.Numbered,
        levelText: getConvertAutoNumCharacterText(buAutoNum, characterIndex),
        color: characterStyle.color,
        fontSize: characterStyle.fontSize * buSzPct,
        fontFamily: characterStyle.fontFamily,
        opacity,
    };
}

function convertImage({ character, level, characterStyle, opacity }) {
    const { buBlip, buSzPct = 1 } = character;
    const { blip } = buBlip;
    const fontSize = (characterStyle?.fontSize && characterStyle.fontSize * buSzPct);
    const { h: height = 100, w: width = 100 } = getUrlQuery(blip?.src);
    // 图片
    return {
        listLevel: level,
        listFormat: ListFormat.Bullet,
        levelText: '',
        src: blip?.src,
        height: Number(height),
        width: Number(width),
        opacity,
        fontSize,
    };
}
